import _styled, { default as _styled2 } from "styled-components";
import React from "react";
type Props = {
  activeSlideIndex: number;
  totalSlides: number;
};
export function Progress(props: Props) {
  const {
    activeSlideIndex,
    totalSlides
  } = props;
  const [progress, setProgress] = React.useState(0);
  const trackRef = React.useRef<HTMLDivElement>(null);
  React.useEffect(() => {
    if (!trackRef.current) {
      return;
    }
    setProgress((activeSlideIndex + 1) / totalSlides);
  }, [activeSlideIndex, totalSlides]);
  return <_StyledDiv ref={trackRef}>
      <_StyledDiv2 style={{
      transform: `scaleX(${progress})`
    }} />
    </_StyledDiv>;
}
var _StyledDiv = _styled("div").withConfig({
  componentId: "sc-sf-gk36n7-0"
})({
  "backgroundColor": "rgb(75 46 248 / 0.2)"
});
var _StyledDiv2 = /*#__PURE__*/_styled2("div").withConfig({
  displayName: "progress___StyledDiv2",
  componentId: "sc-76z23j-0"
})({
  "height": "0.4rem",
  "width": "100%",
  "transformOrigin": "left",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(75 46 248 / var(--tw-bg-opacity))",
  "transitionProperty": "transform",
  "transitionDuration": "500ms"
});